<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.DocumentDelivery')"
      width="380px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <el-form label-width="65px" label-position="left">
          <el-radio-group v-model="sendOutDialog.customerType" no="1" class="custom" @change="sendOutCustomTypeChange()">
            <el-radio :label="0">{{ $t('SeaExport.bookingParty') }}</el-radio>
            <el-radio :label="1">{{ $t('SeaExport.Customer') }}</el-radio>
            <el-radio :label="2">{{ $t('SeaExport.CustomsBrokerOthers') }}</el-radio>
          </el-radio-group>
          <el-form-item :label="$t('SeaExport.ReceiverCompanyName')">
            <el-input v-model="sendOutDialog.formData.receiveCompany" no="2" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Receiver2')">
            <el-input v-model="sendOutDialog.formData.receivePerson" no="3" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReceivingAddress')">
            <el-input v-model="sendOutDialog.formData.receiveAddress" no="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContactNumber')">
            <el-input v-model="sendOutDialog.formData.receiveTel" no="5" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CourierOrderNo')">
            <el-input v-model="sendOutDialog.formData.expressNo" no="6" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button no="7" type="primary" @click="sendOutPrint">{{ $t('SeaExport.print') }}</el-button>
          <el-button no="8" type="primary" @click="sendOutSend">{{ $t('SeaExport.Send2') }}</el-button>
          <el-button no="9" @click="cancel">{{ $t('SeaExport.Cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { batchSendOutFileHandler } from '@/api/seaExport/file'
import { File } from '@/class/model/booking/File'
import $store from '@/store'
import { Company } from '@/class/model/mdm/Company'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'

export default {
  name: 'DcSendOutWindow',
  components: { CargoAdvanceSelect, cargoTemplateSelectorDialog },
  props: {
    visible: { type: Boolean, required: true },
    sendOutDialog: { type: Object, required: true },
    selectedFiles: { type: Array, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'JOBLIST',
        data: {}
      }
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  mounted() {
    this.sendOutCustomTypeChange()
  },
  methods: {
    cancel() {
      this.sendOutCustomTypeChange()
      this.$emit('dcSendOutVisible')
    },
    sendOutPrint() {
      if (!this.sendOutCheckForm()) return
      this.sendOutDialog.printFlag = true
      this.sendOutSend()
    },
    sendOutSend() {
      if (!this.sendOutCheckForm()) return
      const fileList = []
      for (const file of this.selectedFiles) {
        file.sendReceiveCompany = this.sendOutDialog.formData.receiveCompany
        file.sendReceivePerson = this.sendOutDialog.formData.receivePerson
        file.sendExpressAddress = this.sendOutDialog.formData.receiveAddress
        file.sendReceiveTel = this.sendOutDialog.formData.receiveTel
        file.sendExpressNo = this.sendOutDialog.formData.expressNo
        file.SendBy = $store.getters.userId
        file.sendDate = new Date()
        file.state = 1
        fileList.push(file)
      }
      batchSendOutFileHandler(fileList).then(res => {
        if (this.sendOutDialog.printFlag) {
          this.sendOutDoPrint()
        } else {
          this.$message.success(this.$t('Clearing.SentOut'))
        }
        this.sendOutDialog.visible = false
        this.$emit('successHandler', fileList)
      })
    },
    sendOutDoPrint() {
      const params = {}
      params.FILE_UUID = this.selectedFiles[0].uuid
      params.USER_ID = $store.getters.userId
      this.templateSelectorDialog.cxt = new File(this.selectedFiles[0])
      this.templateSelectorDialog.category = 'FILE'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    sendOutCheckForm() {
      let warning = ''
      if (!this.sendOutDialog.formData.receiveCompany) {
        warning = this.$t('SeaExport.InputReceivingcompany')
      } else if (!this.sendOutDialog.formData.receivePerson) {
        warning = this.$t('SeaExport.InputRecipient')
      } else if (!this.sendOutDialog.formData.receiveAddress) {
        warning = this.$t('SeaExport.InputReceivingAddress')
      } else if (!this.sendOutDialog.formData.receiveTel) {
        warning = this.$t('SeaExport.InputContactNumber')
      } else if (!this.sendOutDialog.formData.expressNo) {
        warning = this.$t('SeaExport.InputExpressNumber')
      }
      if (warning) {
        this.$message.warning(warning)
        return false
      }
      return true
    },
    clearForm() {
      this.sendOutDialog.formData.receiveCompany = ''
      this.sendOutDialog.formData.receiveAddress = ''
      this.sendOutDialog.formData.receivePerson = ''
      this.sendOutDialog.formData.receiveTel = ''
    },
    sendOutCustomTypeChange() {
      this.clearForm()
      switch (this.sendOutDialog.customerType) {
        case 0:
          this.setByCompanyId(this.job.bookingAgent)
          break
        case 1:
          this.setByCustomerId(this.job.customerId)
          break
        case 2:
          this.setByCompanyId(this.sendOutDialog.sendType === 2 ? this.job.customsBroker : this.selectedFiles[0].customsBroker)
          break
      }
    },
    async setByCustomerId(cmpIdx) {
      let company = { cmpIdx: cmpIdx }
      company = new Company(company)
      if (company != null) {
        const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
        if (!companyCache) {
          return
        }
        this.sendOutDialog.formData.receiveCompany = companyCache.chineseName
        this.sendOutDialog.formData.receiveAddress = companyCache.address
        const contacts = await company.getContactsBycmpIdx()
        let contact = null
        // 获取业务上的联系人，若业务上无 则取默认联系人
        if (contacts) {
          for (const item of contacts) {
            if (item.contactPerson === this.job.customerContact) {
              contact = item
              break
            }
          }
          if (!contact) {
            for (const item of contacts) {
              if (item.defaultContact) {
                contact = item
                break
              }
            }
          }
        }
        console.log(contact)
        if (contact) {
          this.sendOutDialog.formData.receivePerson = contact.contactPerson
          this.sendOutDialog.formData.receiveTel = contact.telephone
        }
      }
    },
    async setByCompanyId(cmpIdx) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
      if (!companyCache) {
        return
      }
      this.sendOutDialog.formData.receiveCompany = companyCache.chineseName
      this.sendOutDialog.formData.receiveAddress = companyCache.address
      let company = { cmpIdx: cmpIdx }
      company = new Company(company)
      let contact = null
      if (company != null) {
        const contacts = await company.getContactsBycmpIdx()
        if (contacts) {
          for (const item of contacts) {
            if (item.defaultContact) {
              contact = item
              break
            }
          }
          if (contact) {
            this.sendOutDialog.formData.receivePerson = contact.contactPerson
            this.sendOutDialog.formData.receiveTel = contact.telephone
          }
        }
      }
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}
</style>

